export enum BetType {
    DTBTie,
    DTBDragonWin,
    DTBTigerWin,
    DTBMaxBet,
}
